import { IComponentOptions, IController, IFormController } from 'angular';
import { IEssentialInfo } from '../../core/entities/profile';
import { AuthService } from '../../core/services/auth/auth.service';
import { UserService } from '../../core/services/user/user.service';
import { ToastrService } from '../../core/services/toastr/toastr.service';
import { $Event } from '../../helpers';
import { cloneDeep } from 'lodash-es';
import './essential-info-form.component.scss';

class EssentialInfoCtrl implements IController {
  static $inject = [
    'AuthService',
    'UserService',
    'ToastrService'
  ];
  updated: ($event: $Event<IEssentialInfo>) => void;
  data: IEssentialInfo;
  essentialInfo: IEssentialInfo;
  form: IFormController;

  isMobile: boolean = false;

  constructor(private authService: AuthService,
    private userService: UserService,
    private toastrService: ToastrService) {
  }

  $onInit() {
    console.log(this.data);
    this.essentialInfo = cloneDeep(this.data);
    this.isMobile = window.innerWidth < 800 ? true :false;
  }

  get isCandidate(): boolean {
    return this.authService.userRoles.isCandidate;
  }

  save() {
    console.log(this.essentialInfo);
    const update: IEssentialInfo = {
      adminInfo: this.essentialInfo.adminInfo
    };
    if (this.isCandidate) {
      update.dailyReport = this.essentialInfo.dailyReport;
      update.downloadCV = this.essentialInfo.downloadCV;
      update.personalInfo = this.essentialInfo.personalInfo;
    }
    this.userService.updateEssentialInfo(update)
      .then(() => {
        this.updated(new $Event(this.essentialInfo));
        this.toastrService.success('Essential Info updated successfully');
      })
      .catch((err) => {
        console.log(err);
        this.toastrService.error('Essential Info update failed');
      });
  }
}

export const EssentialInfoFormComponent: IComponentOptions = {
  controller: EssentialInfoCtrl,
  template: require('./essential-info-form.component.html'),
  bindings: {
    data: '<',
    updated: '&'
  }
};



// WEBPACK FOOTER //
// ./app/components/essential-info-form/essential-info-form.component.ts